import { FC } from 'react';
import { ITeamReport } from '../../models/reports.internal';
import { reduceWithSum } from '../../utils/arrayUtils';
import { objectToArray } from '../../utils/objectUtils';
import { nameof } from '../../utils/stringUtils';
import getTotalWorkItemCounts from '../../calculations/getTotalWorkItemCounts';
import useGetTeamReports from '../../shared/hooks/useGetTeamReports';
import ReportsList, { SortOptions } from '../../components/shared/ReportList';
import TeamReport from './TeamReport';

const sortOptions: SortOptions<ITeamReport> = {
  'Logged In': { selector: (tr) => reduceWithSum(objectToArray(tr.currentMemberAvailability, (key, value) => key !== 'LoggedOut' ? value : 0)) },
  'Busy': { selector: (tr) => tr.currentMemberAvailability.Busy },
  'On Break': { selector: (tr) => tr.currentMemberAvailability.Break },
  'Available': { selector: (tr) => tr.currentMemberAvailability.Idle },
  'Tasks Handled': { selector: (tr) => getTotalWorkItemCounts(tr.workItemsByMedia).handled },
  'Tasks Missed': { selector: (tr) => getTotalWorkItemCounts(tr.workItemsByMedia).missed },
};

const TeamReportsList: FC = () => (
  <ReportsList
    layout="list"
    reportData={useGetTeamReports()}
    reportComponent={TeamReport}
    sortOptions={sortOptions}
    itemsName="teams"
  />
);

TeamReportsList.displayName = nameof({ TeamReportsList });
export default TeamReportsList;